import { Facebook, Instagram, Mail, Globe } from "lucide-react";

const LOGO = "/images/logo-2026.png";

export default function Footer({ onRegister }) {
  return (
    <footer className="relative bg-black border-t border-[#27272A]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <img src={LOGO} alt="Freedom In Me Business Showers" className="h-20 w-auto" />
            <p className="mt-6 text-[#A3A3A3] text-base max-w-md">
              Freedom In Me Business Showers connects new businesses to people and resources —
              through training, coaching, community, cash awards, and access to capital.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#00A651] font-bold">Event</div>
            <ul className="mt-4 space-y-2 text-sm text-[#E5E5E5]">
              <li><a href="#overview" className="hover:text-[#00A651]">Overview</a></li>
              <li><a href="#options" className="hover:text-[#00A651]">Race Options</a></li>
              <li><a href="#pricing" className="hover:text-[#00A651]">Pricing</a></li>
              <li><a href="#details" className="hover:text-[#00A651]">Event Day</a></li>
              <li><a href="#faq" className="hover:text-[#00A651]">FAQ</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#EC008C] font-bold">Get in touch</div>
            <ul className="mt-4 space-y-2 text-sm text-[#E5E5E5]">
              <li className="flex items-center gap-2"><Globe className="w-4 h-4 text-[#EC008C]" /> businessshowers.org/5k</li>
              <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-[#EC008C]" /> hello@businessshowers.org</li>
              <li className="flex items-center gap-3 pt-2">
                <a className="hover:text-[#00A651]" href="#"><Facebook className="w-5 h-5" /></a>
                <a className="hover:text-[#EC008C]" href="#"><Instagram className="w-5 h-5" /></a>
              </li>
            </ul>
            <button
              onClick={onRegister}
              className="mt-6 bg-[#00A651] hover:bg-[#1FBF3E] text-black font-bold uppercase tracking-widest text-sm px-6 py-3 transition-all"
            >
              Register Now →
            </button>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-[#27272A] flex flex-col md:flex-row md:items-center justify-between gap-3 text-xs text-[#71717A]">
          <div className="uppercase tracking-widest">
            © {new Date().getFullYear()} Freedom In Me Business Showers · All rights reserved
          </div>
          <div className="uppercase tracking-widest">
            Saturday, November 7, 2026 · Frank Liske Park · Concord, NC
          </div>
        </div>
      </div>
    </footer>
  );
}
